<template>
  <div class="head-container">
    <div class="header-wrap safe-wrapper">
      <div class="h-l">
        <span>Hi~欢迎加入康养合规专业委员会</span>
      </div>
    </div>
    <div class="nav-banner">
      <div class="nav-banner-main safe-wrapper">
        <div class="banner-main-l">
          <span class="banner-logo">
            <img src="../assets/image/hgs-logo2.png" alt="" />
          </span>
          <h1 class="banner-title">
            <span style="display:flex;align-items:last baseline;">
              <span class="banner-title-text">养老合规师职业能力（水平）考试</span>
            </span>
            
            <span class="banner-title-tips">养老合规师考试网 <span>www.yanglao365.org.cn</span></span>
          </h1>
        </div>
      </div>
    </div>
 
    <div class="nav-list">
      <div class="nav-menu-list safe-wrapper">
        <div :class="`${activeMenu == item.jump_url ? 'hover':''}`" v-for="(item,index) in menusList" :key="index">
          <router-link :to="`${item.jump_url == '/Home'?'/Home': item.jump_url +'?menu_id='+ item.id }`">{{  item.menu_name  }}</router-link>
        </div>
      </div>
    </div>
    <!-- 最新公告 -->
    <div class="announcement-wrapper" v-if="is_show">
      <div class="announcement-content">
        <div class="announcement-content-left">
          <img src="../assets/image/icon-suona.jpg">
          <span>最新公告</span>
        </div>
        <div class="announcement-content-right" style="height: 48px;">
          <div class="str_move">
            <a href="javascript:0;" v-for="(item, index) in ggtz_info.news_list" :key="index"  class="notice-bar__wrap_text">
              {{ item.title }}
            </a>
          </div>
          
        </div>
      </div>
  </div>
</div>


</template>

<script>
import { getMenus,getHome } from '../api/api';
export default {
  components: {

  },
  data(){
    return{
      ggtz_info: {}, // 公告通知
      menusList:[],
      is_show:true,
    }
  },
  watch: {
    $route() {
      this.setCurrentRoute();
    }
  },
  computed: {
   

    // avatar() {
    //   return this.$store.state.user.realAvatar
    // },
    activeMenu() {
      const route = this.$route;
      console.log(route)
      const { meta, path,fullPath } = route;
      return '' || path;
    },
  },
 
  mounted() {
 
  },
  created(){
    this.setCurrentRoute();
    this.getMenus();
    this.getHome();

  },
  methods: {
    getMenus(){
      let that = this;
      getMenus({}).then( res =>{
        if(res.code == 0){
          that.menusList = res.data;
        }
      }).catch( e =>{
        console.log(e)
      })
    },
    setCurrentRoute() {
      console.log(this.$route.path); 
      if(this.$route.path != '/Home'){
        this.is_show = false
      }else{
        this.is_show = true
      } 
    },
    goToHome(){
      this.$router.push({
        path:'/Home',
        query:{
        }
      })
    },
    search(e){

    },
    getHome(){
      let that = this;
      getHome({}).then(res =>{
        if(res.code == 0){
          let data = res.data.list;
          data.forEach( ele =>{
            if(ele.id == 1){
              that.ggtz_info = ele;
              that.ggtz_info.news_list = ele.news_list.slice(0,5);
            }
          });
        }
      }).catch( e=>{
        console.log(e)
      })
    }, 
    
  },
};
</script>

<style lang="scss" scoped>
  .head-container {
    box-shadow: 0 0 6px -3px #999;
  }
  .safe-wrapper {
    width: 1200px;
    margin: auto;
  }
  .header-wrap {
    display: flex;
    justify-content: space-between;
    height: 40px;
  }
  .h-l, .h-r {
    display: flex;
    align-items: center;
  }
  .h-l span {
    font-size: 12px;
    color: #666;
    padding-left: 10px;
  }
  
  .nav-banner {
    width: 100%;
    height: 260px;
    // background: $g_bg;
    color: #fff;
    background-image: linear-gradient(to bottom, #33adb3,#3584a7,#406393);
    // background-size: 500%;
    // animation: bgAnimation 15s linear infinite;
    // background-image: url(../assets/image/nav-banner-new.png);
    // background-size: cover;
    // background-repeat: no-repeat;
  }
  @keyframes bgAnimation {
    0% {
      background-position: 0% 50%;
    }
    50% {
      background-position: 100% 50%;
    }
    100% {
      background-position: 0% 50%;
    }
  }
  .nav-list {
    width: 100%;
    height: 55px;
    background-color: $g_nav_bg;
  }
  .nav-banner-main {
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .banner-main-l {
    flex: 1;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .banner-main-l .banner-logo {
    width: 190px;
    height: 190px;
    border-radius: 50%;
    margin-right: 26px;
    margin-left: -10px;
    background-size: cover;
    background-repeat: no-repeat;
  }
  .banner-main-l .banner-logo img {
    width: 100%;
    height: 100%;
  }
  h1 {
    font-size: 20px;
  }
  .banner-main-l .banner-title {
    color: #fff;
    letter-spacing: 1px;
  }
  .banner-main-l .banner-title .banner-title-text {
    display: block;
    font-size: 50px;
    margin-bottom: 3px;
  }
  .banner-main-l .banner-title .banner-title-tips {
    display: block;
    font-size: 34px;
  }
  .banner-main-l .banner-title .banner-title-tips span {
    display: inline-block;
    font-size: 22px;
  }
  .nav-menu-list{
    display: flex;
    align-items: center;
    // justify-content: space-between;
    height: 100%;
    background: $g_nav_bg;
    &>div{
      flex: 1;
      height: 55px;
      line-height: 55px;
      min-width: 120px;
      font-size: 14px;
      text-align: center;
      padding: 0 10px;
      color: #fff !important;
    }
    &>div>a{
      color: #fff !important;
      font-size: 15px;
      width: 100%;
      height: 100%;
      display: inline-block;
    }
    &>div.hover{
      background-color: $g_nav_active_bg !important;
      border-bottom: none !important;
    }
    &>div:hover{
      background-color: $g_nav_active_bg !important;
      border-bottom: none !important;
    }
    /deep/ .el-menu{
      background: $g_nav_bg;
    }
    /deep/ .el-menu--horizontal>.el-menu-item{
      height: 55px;
      line-height: 55px;
      min-width: 120px;
      font-size: 14px;
      text-align: center;
      padding: 0 10px;
    }
    /deep/ .el-menu--horizontal>.el-menu-item.is-active{
      background-color: $g_nav_active_bg !important;
      border-bottom: none !important;
    }
    /deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):focus,
    /deep/ .el-menu--horizontal>.el-menu-item:not(.is-disabled):hover,
    /deep/ .el-menu--horizontal>.el-submenu .el-submenu__title:hover{
      background-color: $g_nav_active_bg !important;
    }
  }
  .announcement-wrapper {
    width: 100%;
    height: 48px;
    background: #dae9ff;
  }
  .announcement-wrapper .announcement-content {
    width: 1200px;
    height: 48px;
    margin: 0 auto;
    display: flex;
    // justify-content: center;
    align-items: center;
  }

  .announcement-content-left {
    height: 34px;
    width: 100px;
    background-image: url(../assets/image/suona-bg.jpg);
    background-size: 100% 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-right: 10px;
  }

  .announcement-content-left img{
    width: 19px;
    height: 17px;
    margin-right: 4px;
    margin-left: 10px;
  }
  .announcement-content-left span{
    color: #fff;
    font-size: 13px;
  }
  .announcement-content-right{
    flex: 1;
    background: #dae9ff;
    overflow: hidden;
    position: relative;
  }
  .str_move{
    white-space:nowrap;
    height: 100%;
    cursor: move;
    animation: move 26s linear infinite;
  }
  .str_move a.notice-bar__wrap_text {
    font-size: 14px;
    font-weight: 500;
    color: $g_color;
    line-height: 48px;
    padding-right: 60px;
  }
  
  
@keyframes move {
  0% {
    transform: translateX(100%);
  }
  100% {
    transform: translateX(-100%);
  }
}
  @media screen and (max-width: 1400px) {
  // .announcement-content{
  //   padding-left: 70px !important;
  // }
  // .banner-main-l .banner-title .banner-title-text{
  //   font-size: 36px;
  // }
  // .banner-main-l .banner-title .banner-title-tips{
  //   font-size: 24px;
  // }
}
</style>
